import { useFluentContext } from "@fluentui/react-northstar";
import { ICSSInJSStyle } from "@fluentui/react-northstar";

interface ErrorPanelStyles {
  imgStyles: ICSSInJSStyle;
  container: ICSSInJSStyle;
  descriptionStyles: ICSSInJSStyle;
  titleStyles: ICSSInJSStyle;
}

export const useErrorPanelStyles = (): ErrorPanelStyles => {
  const { theme } = useFluentContext();
  return {
    imgStyles: {
      width: "120px",
    },
    container: {
      width: "100vw",
      height: "100vh",
      backgroundColor: theme.siteVariables.colorScheme.default.background4,
    },
    descriptionStyles: {
      maxWidth: "462px",
      textAlign: "center",
    },
    titleStyles: {
      textAlign: "center",
    },
  };
};
